<!--
 * @Description: 货源方订单列表
 * @Author: l_hc
 * @LastEditors: 请在根目录下.vscode改成你的名字
 * @Date: 2019-07-23 20:37:48
 * @LastEditTime: 2019-09-02 18:47:38
 -->
<template>
  <div class="order-info">
    <div class="goods-head hidden">
      <div class="slider-list">
        <div class="item selected">订单列表</div>
      </div>
      <!-- 查询表单  -->
      <div class="goods-head-form">
        <div class="fileds">
          <el-form
            ref="ruleForm"
            :inline="true"
            label-width="6em"
            :model="formInline"
            class="demo-form-inline"
          >
            <el-form-item prop="orderNum" label="订单编号" class="bottom9">
              <el-input v-model.trim="formInline.orderNum" placeholder="请输入" @keyup.enter.native="getData" />
            </el-form-item>
            <el-form-item prop="orderStatus" label="订单状态" class="bottom9">
              <el-select v-model="formInline.orderStatus" placeholder="请选择">
                <el-option v-for="item in dict.orderStatusLabel" :key="item.id" :label="item.label" :value="item.value" />
              </el-select>
            </el-form-item>
            <el-form-item prop="goodsType" label="货物类型">
              <el-select v-model="formInline.goodsType" placeholder="请选择">
                <el-option v-for="item in dict.goodsTypeLabel" :key="item.id" :label="item.label" :value="item.value" />
              </el-select>
            </el-form-item>
            <el-form-item class="date-picker" label="生成日期">
              <el-date-picker
                v-model="dateval"
                type="daterange"
                value-format="yyyy-MM-dd"
                align="right"
                :editable="false"
                unlink-panels
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                :picker-options="pickerOptions"
              />
            </el-form-item>
          </el-form>
        </div>
        <div class="buttons">
          <el-button
            size="small"
            style="background-color: #BE2316;border-color: #F56C6C;"
            class="form-item-btn"
            type="primary"
            @click="query"
          >
            <i class="el-icon-search" />查询
          </el-button>
          <el-button
            size="small"
            style="background-color: #BE2316;border-color: #F56C6C;"
            class="form-item-btn"
            type="primary"
            @click="resetForm('ruleForm')"
          >
            <i class="el-icon-delete-solid" />
            重置
          </el-button>
        </div>
      </div>
    </div>
    <div class="table">
      <div class="table-warp">
        <div class="table-head hidden">
          <el-row class="center">
            <el-col :span="5">订单编号</el-col>
            <el-col :span="4">货物名称</el-col>
            <el-col :span="4">货源单位</el-col>
            <el-col :span="4">承运单位</el-col>
            <el-col :span="2">总价</el-col>
            <el-col :span="2">订单状态</el-col>
            <el-col :span="3">操作</el-col>
          </el-row>
        </div>
        <div v-loading="loading" class="table-body">
          <template v-if="!loading && tableData.length < 1">
            <div class="no-data-info">
              <font>暂无匹配数据</font>
            </div>
          </template>
          <div v-for="(item, index) in tableData" :key="index" class="table-body-item">
            <el-row type="flex" align="middle" class="center table-body-item-head hidden" >
              <el-col :span="5">
                <div>{{ item.orderNum }}</div>
              </el-col>
              <el-col :span="4">
                <div class="logo">
                  <span class="iconfont" :class="goodstypeicon(item.goodsTypeLabel)" />
                </div>
                <div>{{ item.goodsTypeLabel }}—{{ item.goodsName }}</div>
              </el-col>
              <el-col :span="4">
                <div class="logo">
                  <img :src="item.goodsCompanyLogo | getImg">
                </div>
                <div class="name">{{ item.goodsCompany }}</div>
              </el-col>
              <el-col :span="4">
                <div class="logo">
                  <img :src="item.transportCompanyLogo | getImg">
                </div>
                <div class="name">{{ item.transportCompany }}</div>
              </el-col>
              <el-col :span="2">
                <div>{{ item.money }}元</div>
              </el-col>
              <el-col :span="2">
                <div :style="{color: orderStatusLabel(item.orderStatusLabel)}">{{ item.orderStatusLabel }}</div>
              </el-col>
              <el-col :span="3">
                <el-button v-if="item.orderStatusLabel == '待运输'" style="color: #66b1ff;" type="text" @click="cancel(item)">取消订单</el-button>
                <!--<el-button style="color: #66b1ff;" type="text" @click="cancel(item)">取消订单</el-button>-->
                <el-button
                  class="details"
                  plain
                  size="mini"
                  @click="active == index ? active = -1 : active = index"
                >
                  详情
                  <i
                    :class="{expand: active == index ? true : false}"
                    class="el-icon-d-arrow-right"
                  />
                </el-button>
              </el-col>
            </el-row>
            <transition name="fade">
              <order-list-table-item v-if="active == index" :table-data="item" />
            </transition>
          </div>
        </div>
        <!-- 分页 -->
        <article class="main-pagination hidden">
          <el-pagination
            :current-page="pagination.pageNo"
            :total="pagination.total"
            :page-size="pagination.pageSize"
            layout="prev, pager, next, jumper,total, sizes"
            @current-change="changeCurrent"
            @size-change="changeSize"
          />
        </article>
      </div>
    </div>
    <CancelDialog
      v-if="dialogShow"
      :dialog-show="dialogShow"
      :pop-data="cancelPopData"
      @getList="getData"
      @closeDialog="closeDialog"
    />
  </div>
</template>

<script>
import { getOrderListAll, deleteStorageCmsOrder } from '@/api/monitor/orderInfo'
import { getDict } from '@/api/common'
import { Page } from '@/utils/commonDataModel'
import OrderListTableItem from '../components/OrderListTableItem'
import CancelDialog from './components/cancelDialog'
export default {
  name: 'SupplyOrder',
  components: {
    OrderListTableItem,
    CancelDialog
  },
  data() {
    const pickerOptions = {
      shortcuts: [
        {
          text: '最近一周',
          onClick(picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
            picker.$emit('pick', [start, end])
          }
        },
        {
          text: '最近一个月',
          onClick(picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
            picker.$emit('pick', [start, end])
          }
        },
        {
          text: '最近三个月',
          onClick(picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
            picker.$emit('pick', [start, end])
          }
        }
      ]
    }
    return {
      // 取消订单弹窗状态
      dialogShow: false,
      cancelPopData: [],
      // 时间选择器快捷方式
      pickerOptions,
      // 时间数组
      dateval: [],
      // 查询条件
      formInline: {
        orderNum: '', // 订单编号
        orderStatus: '', // 订单状态
        goodsType: '', // 货物类型
        startSportDate: '', // 订单创建日期
        stopSportDate: '' // 订单创建结束
      },
      // 字典
      dict: {
        goodsTypeLabel: [], // 货物类型
        orderStatusLabel: [] // 订单状态
      },
      // 货物类型字典
      // 展开详情的索引
      active: -1,

      // 数据
      tableData: [],
      loading: true,
      // 分页数据
      pagination: new Page()
    }
  },
  watch: {
    // 处理获取到的时间格式
    dateval: {
      handler(val) {
        let startSportDate = ''
        let stopSportDate = ''
        if (val) {
          startSportDate = val[0]
          stopSportDate = val[1]
        }
        this.formInline.startSportDate = startSportDate
        this.formInline.stopSportDate = stopSportDate
      },
      deep: true
    }
  },
  created() {
    this.getDict('goodsType')
    this.getDict('orderStatus')
    // 预约成交过来的数据
    if (this.$route.params.data != undefined) {
      console.log('货源', this.$route.params.data)
    }
    // 消息通知过来的数据
    if (this.$route.params.noticeId != undefined) {
      console.log('消息通知过来的数据(storageOrderList)', 'id:' + this.$route.params.noticeId, 'type:' + this.$route.params.noticeMark)
      const oid = {
        id: this.$route.params.data.noticeModuleId
      }
      console.log(oid)
      getOrderListAll(Object.assign({
        pageSize: this.pagination.pageSize,
        pageNo: this.pagination.pageNo
      }, oid)).then(res => {
        console.log(res)
        this.tableData = res.result.rows
        this.pagination.total = res.result.total
        this.loading = false
      })
    } else {
      this.getData()
    }
  },
  mounted() {
    document.onkeydown = (e) => {
      // console.log(e)
      if (e.keyCode === 13) {
        this.query()
      }
    }
  },
  methods: {
    // 获取数据
    getData() {
      const params = JSON.parse(JSON.stringify(this.formInline))
      params.rentDateval = JSON.stringify(params.rentDateval)
      params.dateval = JSON.stringify(params.dateval)
      getOrderListAll(Object.assign({
        pageSize: this.pagination.pageSize,
        pageNo: this.pagination.pageNo
      }, params)).then(res => {
        this.tableData = res.result.rows
        this.pagination.total = res.result.total
        this.loading = false
      })
    },
    // 获取字典
    getDict(type) {
      getDict(type).then(res => {
        this.dict[type + 'Label'] = JSON.parse(res.result)
      })
    },
    // 取消订单
    cancel(item) {
      // console.log(item)
      this.dialogShow = true
      this.cancelPopData = item
      // deleteStorageCmsOrder({
      //   orderNum: item.orderNum,
      //   id: item.id,
      //   orderType: item.orderType,
      //   goodsCompanyId: item.goodsCompanyId,
      //   transportCompanyId: item.transportCompanyId
      // }).then(data => {
      //   this.$message({
      //     message: '取消成功',
      //     type: 'success'
      //   })
      //   this.getData()
      // })
      // deleteStorageOrder().then
    },
    // 关闭取消订单修改弹窗
    closeDialog() {
      this.dialogShow = false
    },
    // 查询
    query() {
      this.getData()
    },
    // 订单状态字体颜色
    orderStatusLabel(status) {
      const obj = {
        1: '#148B00',
        2: '#E56100'
      }
      return obj[status]
    },
    // 货物类型icon
    goodstypeicon(goodsTypeLabel) {
      const obj = {
        成品油: 'iconyoupin',
        原油: 'iconyuanyou',
        化工品: 'iconhuagongpin'
      }
      return obj[goodsTypeLabel]
    },
    // 分页-第几页
    changeCurrent(current) {
      this.pagination.pageNo = current
      this.getData()
    },
    // 分页-每页多少条
    changeSize(size) {
      this.pagination = new Page()
      this.pagination.pageSize = size
      this.getData()
    },
    resetForm(formName) {
      this.$refs[formName].resetFields()
      this.dateval = null
      this.getData()
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "../order-list.scss";
  .center {
    text-align: center;
  }
  .logo {
    width: 34px;
    height: 34px;
    margin: 0 auto;
    border-radius: 50px;
    overflow: hidden;
    img{
      width: 100%;
    }
  }
  .name {
    margin-top: 8px;
  }
  .iconfont {
    font-size: 25px;
  }
  .no-data-info {
    background-color: #fff;
    width: 100%;
    text-align: center;
    margin-top: 8px;
    height: 48px;
    line-height: 48px;
    font-size: 15px;
  }
  .order-info {
    font-size: 14px;
    .goods-head {
      padding: 12px 12px;
      box-sizing: border-box;
      border-style: solid;
      border-width: 0 0 1px 0;
      border-color: #f1f1f1;
      background-color: #ffffff;
      width: 928px;
      border: 1px solid #dddddd;
      .slider-list {
        display: block;
        margin: 0 0;
        height: 36px;
        overflow: auto;
        white-space: nowrap;
        border-bottom: 1px solid #f1f1f1;
        &::-webkit-scrollbar {
          height: 0px !important;
          width: 0px !important;
        }
        &::-moz-scrollbar {
          height: 0px !important;
          width: 0px !important;
        }
        .item {
          // height: 35px;
          height: calc(100% - 1px);
          display: inline-block;
          width: 100px;
          font-size: 16px;
          font-weight: 600;
          line-height: 35px;
          margin-right: 12px;
          border-bottom: 1px solid rgba(0, 0, 0, 0);
          text-align: center;
          transition: all 1s;
          color: black;
          cursor: pointer;

          &.selected {
            border-bottom: 1px solid $base-color;
            transition: all 1s;
            color: $base-color;
          }
        }
      }
      .goods-head-form {
        padding-top: 1rem;
        display: flex;
        .fileds {
          flex: 0 1 80%;
          /deep/ .el-form-item {
            width: 230px;
            margin-bottom: 0;
            label:after {
              content: " : ";
            }
            .el-input__inner {
              width: 140px;
            }
          }
          .bottom9 {
            margin-bottom: 9px;
          }
          .date-picker {
            width: 460px;
            .el-input__inner {
              width: 375px;
            }
          }
        }
        .buttons {
          flex: 0 1 20%;
          display: inherit;
          align-items: center;
          justify-content: center;
        }
      }
    }
    .table {
      background-color: #fafafa;
      &-warp {
        margin: 0 auto;
        padding-top: 15px;
        padding-bottom: 8px;
        .table-head {
          margin-bottom: 7px;
          .el-row {
            height: 50px;
            line-height: 50px;
            color: $base-color;
            background-color: #fff;
            border-radius: 4px;
            box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 0.09);
            font-size: 14px;
            font-weight: bold;
          }
        }
      }
      &-body {
        &-item {
          margin-bottom: 10px;
          &-head {
            background-color: #fff;
            box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 0.09);
            border-radius: 4px;
            padding: 10px 0;
          }
        }
      }
    }
  }
  // 显示隐藏动画
  .fade-enter-active,
  .fade-leave-active {
    transition: all 1s;
  }
  .fade-enter {
    opacity: 0;
  }
  .fade-leave-to {
    height: 0;
    overflow: hidden;
  }
  
@media print {
  .hidden{
      display: none;
  }
}
</style>
